module.exports = __webpack_public_path__ + "img/shuffle-01.95d1c8e5.svg";